import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Documents } from ".";

export const ChartBar = ({ data }: Documents) => {
  const { getSizesComponent, setFontSize, componentProperty } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [dataChart, setDataChart] = useState<number[]>([]);

  useEffect(() => {
    if (dataChart && dataChart.length !== 0) {
      setTotal(
        dataChart.reduce(function (soma: number, i: number) {
          return soma + i;
        })
      );
    }
  }, [dataChart]);

  useEffect(() => {
      const daysQtd: number[] = [], daysLabel: string[] = [];
      Object.entries(data.days).map(([key, value], index) => {
        if (Object.prototype.hasOwnProperty.call(data.days, key)) {
          value !== null ? daysQtd.push(parseInt(value))
          :  daysQtd.push(0) ;
        }
        daysLabel.push("dia "+(+index+1))
      });
      setLabels(daysLabel)
      setDataChart(daysQtd)
  }, [data]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: "#fd6763",
        shadeTo: "dark",
        shadeIntensity: 0.65,
      },
    },
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        return labels[opt.dataPointIndex] + ":  " + val;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };

  const series = [
    {
      data: dataChart,
    },
  ];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-documents-sla-delayed" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-documents-sla-delayed", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Documentos com SLA atrasado: ${total} documentos com SLA atrasado`}
        clickable={componentProperty({
          id: "chart-documents-sla-delayed",
          property: "redirect",
        })}
        id="chart-documents-sla-delayed"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
